import * as React from 'react';

import Checkbox from 'af-components/Controls/Checkbox';

interface OwnProps {
	id: number;
	isChecked: boolean;
	onChange: (id: number) => void;
}

type Props = OwnProps;

const SelectionCell: React.FC<Props> = (props) => {
	const { id, isChecked, onChange } = props;

	const handleChange = React.useCallback(() => {
		onChange(id);
	}, [id, onChange]);

	return (
		<Checkbox
			handleChange={handleChange}
			isChecked={isChecked}
		/>
	);
};

export default SelectionCell;
